import {Component} from 'lowkey-component';

import {easing} from '@helpers/easing';
import {MediaQuery} from '@services/MediaQuery';

const DEFAULT_FRICTION = '5';

type Ref = {
  image: Component<HTMLDivElement> | undefined;
};

export default class ParallaxAnimation extends Component<HTMLDivElement, Ref> {
  friction = 0;
  target: HTMLElement | undefined = undefined;
  observer: IntersectionObserver;
  mq = MediaQuery.create();

  constructor(element: HTMLDivElement) {
    super(element);
    this.refs = {
      image: undefined,
    };
    this.onScroll = this.onScroll.bind(this);
    this.onIntersection = this.onIntersection.bind(this);

    this.observer = new IntersectionObserver(this.onIntersection, {
      threshold: [0.0, 1.0],
      rootMargin: '0px',
    });
  }

  didMount() {
    const {friction = DEFAULT_FRICTION, frictionPhone = DEFAULT_FRICTION} =
      this.element.dataset;
    this.friction = this.mq.isPhone()
      ? parseInt(frictionPhone, 10)
      : parseInt(friction, 10);
    if (this.refs.image) {
      const [target] = [
        ...this.refs.image.element.children,
      ] as HTMLDivElement[];
      this.target = target;
      this.target.style.transition = `transform 0.8s ${easing.easeOutQuad}`;
    }
    this.observer.observe(this.element);
  }

  onIntersection(entries: IntersectionObserverEntry[]) {
    for (const entry of entries) {
      window.removeEventListener('scroll', this.onScroll);
      if (entry.isIntersecting) {
        window.addEventListener('scroll', this.onScroll);
      }
    }
  }

  onScroll() {
    const {innerHeight} = window;
    const image = this.refs.image;
    const {top = 0, height = 0} = image?.element.getBoundingClientRect() || {};
    const max = innerHeight + height;
    const pos = innerHeight - top;
    const per = pos / max;
    const y = Math.floor((innerHeight / this.friction) * per);
    if (this.target) {
      this.target.style.transform = `translateY(${-y}px)`;
    }
  }

  didUnmount() {
    window.removeEventListener('scroll', this.onScroll);
    this.observer.disconnect();
  }
}
